// src/utils/formatters.utils.js


export const createFormatters = (lang, unitDisplay = 'long') => {

  const numberFormatter = new Intl.NumberFormat(lang);

  const listFormatter = new Intl.ListFormat(lang, {
    style: 'short',
    type: 'conjunction',
  });

  const unitFormatter = (value, unit) => {
    return new Intl.NumberFormat(lang, {
      style: 'unit',
      unit: unit,
      unitDisplay: unitDisplay,
    }).format(value);
  };

  const currencyFormatter = (value, currency) => {
    return new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: currency
    }).format(value);
  };

  return {
    formatNumber: (value, options = {}) => numberFormatter.format(value, options),
    formatUnit: (value, unit = 'centimeter') => unitFormatter(value, unit),
    currencyFormatter: (value, currency) => currencyFormatter(value, currency),
    formatList: (list) => listFormatter.format(list),
  };
};
